import React, { Fragment } from "react";

const CompanyInformationPost = () => {
  return (
    <Fragment>
      <section className="information">
        <p className="info-message blue">About Comcast NBCUniversal</p>
        <p className="info-description">
          User Name, you've officially taken the first step in becoming a Mentor
          in the incredible world of ime! This means that you are as motivated
          and dedicated as we are, in terms of developing the world we live in
          by sharing your knowledge and skills with individuals inspired by
          leaders such as yourself! The next step is to create at least one
          course before you begin to gain your following and interact with
          users. Once your course is submitted and approved, we will notify you
          and you will be on your way!
        </p>
        <p className="info-message blue cursor">
          <i className="fas fa-globe blue fa-lg mx-5"></i>Website
        </p>
      </section>
    </Fragment>
  );
};

export default CompanyInformationPost;
